import {
  VerticalStack,
  AlphaCard,
  HorizontalStack,
  Button,
  Icon,
  TextField,
  Select,
  Divider,
  Text,
  Checkbox,
  ButtonGroup
} from "@shopify/polaris";

import {
  CustomersMajor,
  BehaviorMajor,
  EditMinor,
  CancelMinor,
  CircleTickMajor
} from '@shopify/polaris-icons';
import { useState } from "react";

import {
  Instagram,
  Youtube,
  Tiktok,
} from "../utils";
import { submitOnboarding } from "../firebase";

export default function LpForm({ formID, submitted, centered = false, customFields = {} }) {
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [submitFormError, setSubmitFormError] = useState(null);
  const [localResponded, setLocalResponded] = useState(null);

  console.log('customFields', customFields)
  const [localForm, setLocalForm] = useState({
    name: '',
    email: '',
    primaryPlatform: 'instagram',
    handle: '',
    customFields: {

    },
  });

  console.log('localForm', localForm)

  async function submitForm() {
    try {
      setSubmitFormError(null);
      setSubmitFormLoading(true);

      // todo add creator data
      await submitOnboarding(
        formID,
        {
          formID,
          ...localForm,
        },
      );
      document.cookie = `formSubmitted=${formID}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
      setLocalResponded(true);
      window.scrollTo(0, 0)
    } catch (e) {
      setSubmitFormError(e.message);
    } finally {
      setSubmitFormLoading(false);
    }
  }

  function handleChange(path, value) {
    const [key, subKey] = path.split('.');
    if (!subKey) {
      setLocalForm({
        ...localForm,
        [key]: value
      })
      return;
    }
    setLocalForm({
      ...localForm,
      [key]: {
        ...localForm[key],
        [subKey]: value
      }
    })
  }

  if (localResponded) {
    return (
      <VerticalStack inlineAlign="center" gap="5">
        <HorizontalStack>
          <Icon source={CircleTickMajor} color="success" />
        </HorizontalStack>
        <Text variant="headingXl" color="subdued">Form Submitted!</Text>
        <Text variant="bodyLg">Thank You</Text>
      </VerticalStack>
    )
  }

  return (
    <VerticalStack gap="8">
      <VerticalStack gap="5">
        <HorizontalStack gap="3" align={centered ? "center" : "start"}>
          <HorizontalStack>
            <Icon source={CustomersMajor} />
          </HorizontalStack>
          <Text variant="headingMd">About You</Text>
        </HorizontalStack>
        <VerticalStack gap="3">
          <TextField label="Name" value={localForm.name} onChange={v => handleChange('name', v)} />
          <TextField type="email" label="Email" value={localForm.email} onChange={v => handleChange('email', v)} />
          {
            /*
              defaultFields['about you'] && (
                <TextField
                  label="About You"
                  maxLength={100}
                  showCharacterCount
                  multiline={2}
                  value={localForm.defaultFields.shortDescription}
                  onChange={v => handleChange('defaultFields.shortDescription', v)}
                  helpText="Who are you & what kind of content do you create?"
                />
              )
              */
          }
        </VerticalStack>
      </VerticalStack>
      <VerticalStack gap="5">
        <HorizontalStack gap="3" align={centered ? "center" : "start"}>
          <HorizontalStack>
            <Icon source={BehaviorMajor} />
          </HorizontalStack>
          <VerticalStack gap="1">
            <Text variant="headingMd">Social Media</Text>
          </VerticalStack>
        </HorizontalStack>
        <VerticalStack gap="3">
          <Select label="What is Your Primary Platform?"
            options={[
              {
                label: (
                  <HorizontalStack blockAlign="center" align="start">
                    <Instagram width="25" />
                    <Text variant="bodySm">Instagram</Text>
                  </HorizontalStack>
                ),
                value: 'instagram'
              },
              {
                label: (
                  <HorizontalStack blockAlign="center" align="start">
                    <Tiktok width="25" />
                    <Text variant="bodySm">TikTok</Text>
                  </HorizontalStack>
                ),
                value: 'tiktok'
              },
              {
                label: (
                  <HorizontalStack blockAlign="center" align="start">
                    <Youtube width="25" />
                    <Text variant="bodySm">YouTube</Text>
                  </HorizontalStack>
                ),
                value: 'youtube'
              }
            ]}
            value={localForm.primaryPlatform}
            onChange={v => handleChange('primaryPlatform', v)}
          />
          {
            localForm.primaryPlatform === 'instagram' ? (
              <TextField label="Your Instagram Handle"
                prefix={
                  <HorizontalStack blockAlign="center" align="center">
                    <Text variant="bodySm">https://instagram.com/</Text>
                  </HorizontalStack>
                }
                value={localForm.handle}
                onChange={v => handleChange('handle', v)}
              />
            ) : localForm.primaryPlatform === 'tiktok' ? (

              <TextField label="Your TikTok Handle"
                prefix={
                  <HorizontalStack gap="1" blockAlign="center" align="center">
                    <Text variant="bodySm">https://tiktok.com/@</Text>
                  </HorizontalStack>
                }
                value={localForm.handle}
                onChange={v => handleChange('handle', v)}
              />
            ) : localForm.primaryPlatform === 'youtube' ? (
              <TextField label="Your YouTube Handle"
                prefix={
                  <HorizontalStack blockAlign="center" align="center">
                    <Text variant="bodySm">https://youtube.com/@</Text>
                  </HorizontalStack>
                }
                value={localForm.handle}
                onChange={v => handleChange('handle', v)} />
            ) : null
          }
        </VerticalStack>
      </VerticalStack>
      <VerticalStack gap="3">
        {
          Object.entries(customFields).map(([key, value]) => {
            if (!value) return null;
            return (
              <VerticalStack gap="2">
                <VerticalStack gap="2">
                  <HorizontalStack align="space-between" blockAlign="end">
                    <Text variant="bodyMd">{value.label}</Text>
                    <HorizontalStack gap="1" blockAlign="end">
                    </HorizontalStack>
                  </HorizontalStack>
                  {
                    value?.type === 'dropdown' ? (
                      <Select value={localForm?.customFields[key]} options={value.options?.map(option => option.label)} onChange={v => {
                        handleChange(`customFields.${key}`, v);
                      }}
                      />
                    ) : value?.type === 'checkbox' ? (
                      <HorizontalStack gap="8" align="start">
                        {
                          value.options?.map(option => (
                            <Checkbox value={localForm?.customFields[key]?.[option.label]} label={option.label} type="checkbox"
                              onChange={v => {
                                handleChange(`customFields.${key}.${option.label}`, v);
                              }
                              }
                            />
                          ))
                        }
                      </HorizontalStack>
                    ) : (
                      <TextField value={localForm?.customFields[key]} requiredIndicator={value.required} multiline={value.multiline ? 2 : 1} onChange={v => {
                        console.log('value', v)
                        handleChange(`customFields.${key}`, v);
                      }} />
                    )
                  }
                </VerticalStack>
              </VerticalStack>
            )
          })
        }
      </VerticalStack>
      <HorizontalStack align="end">
        <Button
          loading={submitFormLoading}
          primary
          onClick={submitForm}
          disabled={
            !localForm?.name
            || !localForm?.email
            || !localForm?.primaryPlatform
            // || defaultFields['about you'] && !localForm?.defaultFields?.shortDescription
            || Object.keys(customFields || {})?.length && Object.keys(customFields).some(key => {
              return !localForm?.customFields?.[key]
            })
            || !localForm?.handle
          }
        >Submit Form</Button>
      </HorizontalStack>
      {submitFormError ? (
        <Text variant="bodySm" color="critical">{submitFormError}</Text>
      ) : null}
    </VerticalStack>
  )
}
